import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatSort,
  MatTableDataSource,
} from "@angular/material";

@Component({
  selector: "app-crm-markets",
  templateUrl: "./crm-markets.component.html",
  styleUrls: ["./crm-markets.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CrmMarketsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  providerId;
  eventId = "";
  eventName = "";
  sportId;
  searchKey = "";
  sportName: string = "";
  providers = ["GeniusPremium"];
  openDate = 0;
  filteredMarkets = new MatTableDataSource<any>();
  currentTab = "UnMapped Markets";

  unmapMarketsTableColumns = [
    "Event Id",
    "Market Id",
    "Market Name",
    "Actions",
  ];

  mappedMarketsTableColumns = [
    "Event Id",
    "Market Id",
    "SR Market Id",
    "Old Market Name",
    "Market Name",
    "Category",
    "Market Status",
    "Actions",
  ];

  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.activetedRoute.queryParams.subscribe((params) => {
      this.providerId = params["providerId"];
      this.sportId = params["sportId"];
      this.eventId = params["eventId"];
      this.eventName = params["eventName"];
      this.sportName = params["sportName"];
      this.openDate = parseInt(params["openDate"]);
    });

    this.getMarkets();
  }

  ngAfterViewInit() {
    this.filteredMarkets.sort = this.sort;
    this.filteredMarkets.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "Market Id":
          return item.marketId;
        case "Market Name":
          return item.marketName;
        case "Market Status":
          return item.status;
        case "Category":
          return item.category;
        default:
          return item[property];
      }
    };
  }

  getMarkets() {
    try {
      let filters = {
        providerId: this.providerId,
        sportId: this.sportId,
        eventId: this.eventId,
      };
      this.appService
        .getPremiumUnmappedMarkets(filters)
        .subscribe((response) => {
          if (response.status === "RS_OK") {
            this.filteredMarkets.data = response.markets;
          } else {
            this.appService.openErrorBar(response.errorDescription);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  onSelectProivder(item) {
    this.filteredMarkets.data = [];
    this.providerId = item;
    this.currentTab = "Mapped Markets";
    this.getMappedMarkets();
  }

  getMappedMarkets() {
    try {
      let filters = {
        providerId: this.providerId,
        sportId: this.sportId,
        eventId: this.eventId,
      };
      this.appService.getPremiumMappedMarkets(filters).subscribe((response) => {
        if (response.status === "RS_OK") {
          this.filteredMarkets.data = response.markets;
          this.ngAfterViewInit();
        } else {
          this.appService.openErrorBar(response.errorDescription);
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  setShowOptions(event) {
    this.filteredMarkets.data = [];
    this.currentTab = event.tab.textLabel;
    if (event.tab.textLabel == "UnMapped Markets") {
      this.providerId = "SportRadar";
      this.getMarkets();
    } else if (event.tab.textLabel == "Mapped Markets") {
      this.providerId = "";
      // this.getMappedMarkets();
    }
  }

  refreshMarkets() {
    if (this.currentTab === "Mapped Markets") {
      this.getMappedMarkets();
    } else {
      this.getMarkets();
    }
  }

  searchHandlerChange() {
    this.filteredMarkets.filter = this.searchKey;
  }

  handleStatus(event, element) {
    let status = "BLOCKED";
    if (event.checked) {
      status = "ACTIVE";
    }
    const payload = {
      eventKey: element.eventKey,
      marketId: element.marketId,
      status: status,
    };
    try {
      this.appService.changeMapMarketStatus(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
        this.getMappedMarkets();
      });
    } catch (err) { }
  }

  blockEvent() {
    if (this.filteredMarkets.data.length < 1) return;
    const payload = {
      eventKey: this.filteredMarkets.data[0].eventKey,
    };
    try {
      this.appService.blockAllMappedMarkets(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
        this.getMappedMarkets();
      });
    } catch (err) {
      console.log(err);
    }
  }

  openMappingModal(market) {
    const dialogRef = this.dialog.open(CRMMappingModal, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        eventName: this.eventName,
        sportId: this.sportId,
        eventId: this.eventId,
        openDate: this.openDate,
        marketId: market.marketId,
        marketName: market.marketName,
        category: market.category.toUpperCase(),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getMarkets();
      }
    });
  }

  goBack() {
    this.router.navigate(["catalog/catalog-mapping-events"], {
      queryParams: {
        providerId: this.providerId,
        sportId: this.sportId,
        sportName: this.sportName,
      },
    });
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  unmapMarket(element) {
    const dialogRef = this.dialog.open(UnmapConfirmationDialog, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      width: "320px",
      maxWidth: "90vw",
      panelClass: "unmap-confirmation-dialog",
      data: {
        marketName: element.marketName,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        const payload = {
          eventKey: element.eventKey,
          marketId: element.marketId,
          marketName: element.marketName,
          oldMarketName: element.oldName,
        };
        try {
          this.appService.unmapPremiumMarket(payload).subscribe((res) => {
            if (res.status === "RS_OK") {
              this.appService.openSuccessBar(res.errorDescription || "Market unmapped successfully");
              this.getMappedMarkets();
            } else {
              this.appService.openErrorBar(res.errorDescription);
            }
          });
        } catch (err) {
          console.log(err);
        }
      }
    });
  }
}

@Component({
  selector: "CRMMappingModal",
  templateUrl: "./crm-mapping.component.html",
  styleUrls: ["./crm-markets.component.scss"],
})
export class CRMMappingModal {
  filteredMarkets = [];
  providerMarkets = [];
  providers = ["GeniusPremium"];
  searchMarket = "";
  providerId = "";
  sportId = "";
  eventId = "";
  selectedMarket;
  ngOnInit() {
    this.onSelectedProviderId(this.providers[0]);
  }
  constructor(
    public dialogRef: MatDialogRef<CRMMappingModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public router: Router
  ) { }

  onChangeSearchInput() {
    if (this.searchMarket.length >= 1) {
      this.filteredMarkets = this.providerMarkets.filter((market) => {
        if (
          market.marketName
            .toLowerCase()
            .includes(this.searchMarket.toLocaleLowerCase()) ||
          market.marketId
            .toLocaleLowerCase()
            .includes(this.searchMarket.toLocaleLowerCase())
        ) {
          return market;
        }
      });
    } else {
      this.filteredMarkets = this.providerMarkets;
    }
  }

  onSelectedProviderId(providerId) {
    this.providerId = providerId;
    this.filteredMarkets = [];
    this.providerMarkets = [];
    this.getMarkets();
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  selectMarketToMap(market) {
    this.selectedMarket = market;
  }
  getMarkets() {
    try {
      if (this.data.sportId) {
        if (this.data.sportId) {
          try {
            this.appService
              .getPremiumUnmappedMarkets({
                providerId: this.providerId,
                sportId: this.data.sportId,
                eventId: this.data.eventId,
              })
              .subscribe((res) => {
                this.providerMarkets = res.markets;
                this.filteredMarkets = res.markets;
                this.sportId = res.sportId;
                this.eventId = res.eventId;
              });
          } catch (err) { }
        }
      }
    } catch (err) { }
  }
  cancelMapping() {
    this.dialogRef.close();
  }

  mapMarket() {
    if (this.selectedMarket && this.selectedMarket.marketId) {
      const payload = {
        providerId: this.providerId,
        sportId: this.sportId,
        eventId: this.eventId,
        marketId: this.selectedMarket.marketId,
        marketName: this.selectedMarket.marketName,
        smarketId: this.data.marketId,
        smarketName: this.data.marketName,
        category: this.data.category,
        status: "BLOCKED",
      };
      try {
        this.appService.mapPremiumMarkets(payload).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.dialogRef.close(true);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
      } catch (err) { }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: "UnmapConfirmationDialog",
  templateUrl: "./crm-unmap-confirmation-dialog.html",
  styleUrls: ["./crm-markets.component.scss"],
})
export class UnmapConfirmationDialog {
  constructor(
    public dialogRef: MatDialogRef<UnmapConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
